export const SORT_OPTIONS = [
  { label: 'A to Z', value: 'asc', isDisabled: false, isChecked: true },
  { label: 'Z to A', value: 'desc', isDisabled: false, isChecked: false },
];

export const SORT_DATE_OPTIONS = [
  { label: 'Ascending', value: 'asc', isDisabled: false, isChecked: true },
  { label: 'Descending', value: 'desc', isDisabled: false, isChecked: false },
];
